import React, { Component } from 'react';
import { ItemCount, ItemFinalTotal } from '../../utility/commonFunctions';
import { Badge } from 'react-bootstrap';
import { connect } from 'react-redux';
import { newNexusRegistrationCodeEnum } from '../../utility/enums';

import './defaultHeader.scss';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        itemCart: state.itemCart,
        orderPromotionDetails: state.orderPromotionDetails,
        shoppingPreference: state.shoppingPreference,
    }
};


class CartBox extends Component {

    viewProductCart() {
        if (this.props.itemCart.length > 0) {
            window.location.href = "/cart";
        }
    };
    render() {
        return (
            <div className="nav-item-navbar cart-box" onClick={this.viewProductCart.bind(this)}>
                <i className="fas fa-shopping-cart">
                    <Badge id="smart-checkout-count">{ItemCount()}</Badge>
                </i> {ItemFinalTotal(this.props.shoppingPreference.shoppingMethod, (this.props.itemCart.length === 1 && this.props.itemCart[0].itemID === newNexusRegistrationCodeEnum.newNexusRegistrationCode))}
            </div>
        );
    }
}

export default connect(mapStateToProps, null)(CartBox);
